import { colors } from '../../../../constants'

const initial = [colors.orange, '#2f9b8f', colors.bluelight, '#bb5ee0', '#56bbc5', colors.red]
let colorPalette = [...initial]
const colorMap = {}

function getColor(key) {
    if (!colorPalette.length) {
        colorPalette = [...initial]
    }

    if (!colorMap[key]) {
        colorMap[key] = colorPalette.shift()
    }

    return colorMap[key]
}

// eslint-disable-next-line import/prefer-default-export
export { getColor }
